import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const RefreshKey = 'Refresh-Token'
const cookieOptions = {
  sameSite: 'Lax',
  secure: typeof window !== 'undefined' && window.location.protocol === 'https:'
}

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, cookieOptions)
}

export function removeToken() {
  return Cookies.remove(TokenKey, cookieOptions)
}

export function getRefreshToken() {
  return Cookies.get(RefreshKey)
}

export function setRefreshToken(token) {
  return Cookies.set(RefreshKey, token, cookieOptions)
}

export function removeRefreshToken() {
  return Cookies.remove(RefreshKey, cookieOptions)
}

export function setBusinessKYC(flag) {
  return Cookies.set('BusinessKYC', flag, { expires: 180, ...cookieOptions })
}
export function setPersonalKYC(flag) {
  return Cookies.set('PersonalKYC', flag, { expires: 180, ...cookieOptions })
}
export function getBusinessKYC() {
  return Cookies.get('BusinessKYC')
}
export function getPersonalKYC() {
  return Cookies.get('PersonalKYC')
}
export function getChainId() {
  return Cookies.get('TREASURE_CHAINID')
}

export function setChainId(data) {
  return Cookies.set('TREASURE_CHAINID', data, cookieOptions)
}
